module.exports = __webpack_public_path__ + "static/media/epowers.82a4b09e.png";